import { ReactElement } from 'react';
import styled from 'styled-components';
import { IBreakdownOverallStatus } from '../../../utils/interfaces';
import { IParsedFunnelSliceModeMeasure } from '../utils/funnel';
import { isNotNil } from '../../../utils/types';
import BadgeRound from '../../BadgeRound';

const TooltipLineContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 4px;
  white-space: nowrap;
`;
const GroupNameLabel = styled.div`
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
`;

const MeasureNameContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;
const MeasureName = styled.div`
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  flex: 1;
  height: 14px;
`;
const ColumnFlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const ConnectedMeasureContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
`;

const ValueLabel = styled.div`
  font-size: 14px;
  font-weight: 500;
`;

interface ISingleValueDisplay {
  value: string | number | ReactElement;
  isBreakdownOverall: IBreakdownOverallStatus;
  measureName: string;
  sliceName: string;
  stepIndex?: number;
  measureLabel?: string;
}
export const singleMeasureValueDisplay = ({
  value,
  isBreakdownOverall,
  measureName,
  sliceName,
  stepIndex,
  measureLabel,
}: ISingleValueDisplay): ReactElement => {
  return (
    <TooltipLineContainer>
      {isBreakdownOverall !== IBreakdownOverallStatus.NoBreakdown && (
        <GroupNameLabel>{sliceName}</GroupNameLabel>
      )}
      <MeasureNameContainer>
        {isNotNil(stepIndex) && (
          <BadgeRound size="small">${stepIndex}</BadgeRound>
        )}
        {isNotNil(measureLabel) && (
          <BadgeRound size="small">{measureLabel}</BadgeRound>
        )}
        <MeasureName>{measureName}</MeasureName>
      </MeasureNameContainer>
      <ValueLabel>{value}</ValueLabel>
    </TooltipLineContainer>
  );
};

interface IFunnelTimeToConvertMeasureValueDisplay {
  value: string | number | ReactElement;
  isBreakdownOverall: IBreakdownOverallStatus;
  firstMeasure: IParsedFunnelSliceModeMeasure;
  lastMeasure: IParsedFunnelSliceModeMeasure;
  sliceName: string;
}

export const funnelTTCAndFreqMeasureValueDisplay = ({
  value,
  isBreakdownOverall,
  firstMeasure,
  lastMeasure,
  sliceName,
}: IFunnelTimeToConvertMeasureValueDisplay): ReactElement => {
  return (
    <TooltipLineContainer>
      <ColumnFlexContainer>
        <ConnectedMeasureContainer>
          <BadgeRound size="small">{firstMeasure.label}</BadgeRound>
          <MeasureName>{firstMeasure.name}</MeasureName>
        </ConnectedMeasureContainer>
        {' to '}
        <ConnectedMeasureContainer>
          <BadgeRound size="small">{lastMeasure.label}</BadgeRound>
          <MeasureName>{lastMeasure.name}</MeasureName>
        </ConnectedMeasureContainer>
        {isBreakdownOverall !== IBreakdownOverallStatus.NoBreakdown && (
          <GroupNameLabel>{sliceName}</GroupNameLabel>
        )}
        <ValueLabel>{value}</ValueLabel>
      </ColumnFlexContainer>
    </TooltipLineContainer>
  );
};
